<template>
  <div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <list-btn :listArr="listArr"></list-btn>
    <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData"
      :columns="tabColumns"
      tabName="business-purchaseout-list"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick"
    ></tab-list>
    <!-- 详情 -->
    <el-dialog
      title="采购退货详情"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag
      @closed="closedDialog"
    >
      <v-detail :sdata="detailSdata" class="contnet_box" style="overflow-y:hidden;"></v-detail>
    </el-dialog>
  </div>
</template>

<script>
import { purchasebackstock } from "api/business.js";
import listBtn from "components/btn/listBtn.vue";
import tabList from "components/table/list.vue";
import searchBox from "./components/list/search.vue";
import vDetail from "./detail.vue";

export default {
  components: {
    listBtn,
    tabList,
    searchBox,
    vDetail
  },
  data() {
    return {
      dialogFormVisible: false,
      detailSdata: {},
      sdata: {},
      listArr: [],
      tabColumns: [
        {
          field: "materailVoucherNo",
          title: "退货编号",
          need: true,
          width: 120
        },
        { field: "voucherDate", title: "凭证日期", width: 100 },
        { field: "postingDate", title: "过账日期", width: 100 },
        { field: "materialCode", title: "物料号", width: 100 },
        { field: "materialDesc", title: "物料描述" },
        {
          field: "factoryCode",
          title: "工厂",
          formatter(row, column, cellValue, index) {
            let code = row.factoryCode ? row.factoryCode : "";
            let desc = row.factoryDesc ? row.factoryDesc : "";
            return code + "-" + desc;
          }
        },
        {
          field: "inventoryCode",
          title: "库存地",
          formatter(row, column, cellValue, index) {
            let code = row.inventoryCode ? row.inventoryCode : "";
            let desc = row.inventoryDesc ? row.inventoryDesc : "";
            return code + "-" + desc;
          }
        },
        /* {field: 'voucherHeaderTxt', title: '备注'}, */
        { field: "projectTxt", title: "备注" }
      ], //表头字段
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 20, //每页显示的数量,
        searchCriteria: {
          //查询的附加条件
        }
      },
      sfromData: {
        purchaseReturnId: 0,
        purchaseInStockId: 0
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //双击
    dbClick(data) {
      this.sdata = data;
      this.goDetail();
    },
    //选中数据
    selectSdata(data) {
      console.log(data, 2565656);
      this.sfromData.purchaseInStockId = data.materialVoucherId;
      this.sfromData.purchaseReturnId = data.materialVoucherId;
      this.sdata = data;
    },
    //获取列表
    async getList() {
      let res = await this.$post(purchasebackstock.list, this.fromData);
      if (res.status && res.data) {
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      } else {
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
    },
    //当前页码改变
    currentChange(currentPage) {
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages) {
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    //搜索
    subSearch() {
      this.fromData.page = 1;
      this.getList();
    },
    handleSelectChange(item, key) {
      if (item.isChecked) {
        item.isChecked = false;
        this.sdata = {};
      } else {
        this.sdata = item;
        this.sdata.index = key;
        item.isChecked = true;
        this.listArr.forEach(items => {
          if (items.materialVoucherId != item.materialVoucherId) {
            items.isChecked = false;
          }
        });
        if (item.maintainStatus === "X") {
          this.sdata.isDel = true;
        } else {
          this.sdata.isDel = false;
        }
      }
    },
    //选择的改变
    changeSelect(val, item, key) {
      this.handleSelectChange(item, key);
    },
    //详情
    async goDetail() {
      if (!this.sdata.materialVoucherId) {
        this.$message.error("请选择要查看的");
        return;
      }
      let res = await this.$get(purchasebackstock.find, this.sfromData);
      this.dialogFormVisible = true;
      if (res.status) this.detailSdata = res.data;
    },
    //详情
    /* async goDetail(){
        if(!this.sdata.materialVoucherId){
          this.$message.error('请选择要查看的记录');
          return;
        }
        this.dialogFormVisible = true;
        let res = await this.$get(purchasebackstock.find,this.sfromData);

        console.log(res.data,'====== 返回的数据 ===');return;
        if(res.status) this.detailSdata = res.data;
      }, */
    //关闭弹出层
    closedDialog() {
      this.dialogFormVisible = false;
    },
    //删除
    del() {
      let vm = this;
      if (!this.sdata.materialVoucherId) {
        this.$message.error("请选择需要删除的");
        return;
      }
      this.$confirm("确定删除这条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await vm.$get(matterApi.del, {
            materialCode: this.sdata.materialCode
          });
          const { data, msg, status, code } = res;
          if (status) {
            this.sdata.isDel = true;
            this.listArr[this.sdata.index] = this.sdata;
            vm.$message.success(msg);
          } else {
            vm.$message.error(msg);
            return false;
          }
        })
        .catch(() => {
          /* this.$message({
						type: 'info',
						message: '已取消删除'
					});  */
        });
    },
    //恢复删除
    restore() {
      let vm = this;
      if (!this.sdata.materialVoucherId) {
        this.$message.error("请选择需要恢复的物料");
        return;
      }
      this.$confirm("恢复此条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await vm.$get(matterApi.restore, {
          materialCode: this.sdata.materialCode
        });
        const { data, msg, status, code } = res;
        if (status) {
          this.sdata.isDel = false;
          this.listArr[this.sdata.index] = this.sdata;
          vm.$message.success(msg);
        } else {
          vm.$message.error(msg);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>
